var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'route--' + _vm.view.toLowerCase(),
    _vm.isOnTop ? 'page--is-top' : 'page--is-scrolled' ],attrs:{"id":"app"}},[_c('Navbar',{attrs:{"logo":_vm.logo,"navItems":_vm.navItems}}),_c('transition',{attrs:{"mode":"out-in","name":"route"}},[_c('router-view')],1),_c('FooterComponent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }